(() => {
	const activeDrawer = (placement, width) => {
		return ["active", `${placement}-0`, `w-[${width ? width : "220px"}]`];
	};
	const deActiveDrawer = (placement) => {
		return [`${placement}-0`, `w-0`];
	};

	const drawers = document.querySelectorAll(".drawer");
	if (drawers) {
		// hide drawer by window screen size
		window.onresize = displayWindowSize;
		window.onload = displayWindowSize;
		function displayWindowSize() {
			let screenSize = window.innerWidth;
			if (screenSize > 768) {
				drawers.forEach((element) => {
					const { classList } = element;
					const { placement, drawerWidth } = element.dataset;
					classList.remove(...activeDrawer(placement, drawerWidth));
					classList.add(...deActiveDrawer(placement));
				});
			}
		}

		drawers.forEach((element) => {
			const { placement, drawerWidth, drawerName } = element.dataset;

			document.querySelectorAll(".drawer-handler").forEach((handler) => {
				const { targetDrawer } = handler.dataset;

				handler.addEventListener("click", () => {
					if (targetDrawer === drawerName) {
						const { classList } = element;
						if (classList.contains("active")) {
							classList.remove(
								...activeDrawer(placement, drawerWidth)
							);
							classList.add(...deActiveDrawer(placement));
						} else {
							classList.remove(...deActiveDrawer(placement));
							classList.add(
								...activeDrawer(placement, drawerWidth)
							);
						}
					} else {
						drawers.forEach((element) => {
							const { classList } = element;
							const { placement, drawerWidth, drawerName } =
								element.dataset;
							if (targetDrawer !== drawerName) {
								classList.remove(
									...activeDrawer(placement, drawerWidth)
								);
								classList.add(...deActiveDrawer(placement));
							}
						});
					}
				});
			});
		});
	}
})();
